import * as React from 'react';
import { CheckoutContext, Steps } from './utils/CheckoutContext';
import { WSAppContext } from '@weddingspot/ws-core-components';
import { Redirect } from 'react-router-dom';
import { getMarketAndRegionURL } from '../../urls';

const styles = require('./CheckOutPage.module.scss');

const Final = () => {
    const {
        step,
        finalMarket, // ToDo: need to add redirect based on market
        setConfirmButtonName,
        setConfirmButtonAction,
    } = React.useContext(CheckoutContext);

    const { userIsAuthenticated, openAuthModal } = React.useContext(WSAppContext);

    const [redirect, setRedirect] = React.useState(false);

    React.useEffect(() => {
        if (step === Steps.Final) {
            setConfirmButtonName('OK');
            setConfirmButtonAction(() => {
                setRedirect(true);
                if (!userIsAuthenticated) {
                    openAuthModal();
                }
            });
        }
    }, [step]);

    return (
        <>
            {redirect && finalMarket && <Redirect to={getMarketAndRegionURL(finalMarket)} />}
            <div className={styles.final}>
                <h1>Cheers!</h1>
                <span>Your request is on its way.</span>
            </div>
        </>
    );
};

export default Final;
